import React from "react";
import { cn } from "../lib/utils";

type ButtonVariant = "primary" | "ghost" | "dark" | "outline";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  href?: string;
  children: React.ReactNode;
  className?: string;
}

const variantClasses: Record<ButtonVariant, string> = {
  primary:
    "inline-flex items-center gap-2.5 bg-lime text-bg rounded-full px-8 py-[0.9rem] text-[13px] font-bold font-body no-underline transition-opacity hover:opacity-85 whitespace-nowrap",
  ghost:
    "inline-flex items-center justify-center gap-2 bg-transparent text-muted border border-border rounded-full px-8 py-[0.9rem] text-[13px] font-medium font-body no-underline whitespace-nowrap transition-[border-color,color] hover:border-white/20 hover:text-text",
  dark: "bg-bg text-lime rounded-full px-8 py-4 text-[13px] font-bold font-body cursor-pointer whitespace-nowrap no-underline text-center transition-opacity hover:opacity-85",
  outline:
    "bg-transparent text-bg/60 border border-bg/20 rounded-full px-8 py-4 text-[13px] font-medium font-body cursor-pointer whitespace-nowrap no-underline text-center transition-[border-color] hover:border-bg/40",
};

export default function Button({
  variant = "primary",
  href,
  children,
  className,
  ...props
}: ButtonProps) {
  const classes = cn(variantClasses[variant], className);

  if (href) {
    return (
      <a
        href={href}
        className={classes}
        onClick={props.onClick as unknown as React.MouseEventHandler<HTMLAnchorElement>}
      >
        {children}
      </a>
    );
  }

  return (
    <button className={classes} {...props}>
      {children}
    </button>
  );
}
